import styled from 'styled-components';

export const LayoutContentContainer = styled.div`
  position: relative;
  min-height: 100vh;
  background: ${({ theme }) => theme.pageBackground};
  color: ${({ theme }) => theme.titleBarColor};
`;
export const StyledTopNavigation = styled.div`
  position: relative;
  z-index: 20;
  height: 48px;
  a {
    text-decoration: none;
    color: inherit;
    &:hover {
      text-decoration: none;
      color: inherit;
    }
  }
`;
export const Spinner = styled.div`
  position: fixed;
  top: calc(50vh + 24px);
  left: 50vw;
  transform: translate(-50%, -50%);
`;
